export const configuration = {
    apiUrl: process.env.REACT_APP_API_URL ||  'https://managefundapi.secretdemo.com',
  }
 
